/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

/**
 * JSON Schema for secondary entrypoint `ng-package.json` description file
 */
export interface NgPackageEntryConfig {
  $schema?: string;
  /**
   * Description of the library's entry point.
   */
  lib?: {
    /**
     * Entry file to the public API (default: `src/public_api.ts`).
     */
    entryFile?: string;
    /**
     * Filename of the auto-generated flat module file (if empty, defaults to the package name as given in `package.json`).
     */
    flatModuleFile?: string;
    /**
     * Embed assets in css file using data URIs - see https://css-tricks.com/data-uris
     */
    cssUrl?: "none" | "inline";
    /**
     * Any additional paths that should be used to resolve style imports
     */
    styleIncludePaths?: string[];
  };
}
